import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import FloatingVue, { Tooltip, VTooltip } from 'floating-vue';
import 'floating-vue/dist/style.css';

import 'vue-multiselect/dist/vue-multiselect.css';
import 'element-plus/dist/index.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import HighchartsVue from 'highcharts-vue';
import ElementPlus from 'element-plus';

import * as Sentry from '@sentry/vue';

const app = createApp(App);

import {
    faHouse,
    faBuilding,
    faPenToSquare,
    faTrashCan,
    faMagnifyingGlass,
    faPlus,
    faLocationDot,
    faFloppyDisk,
    faXmark,
    faClipboardCheck,
    faFolderPlus,
    faClipboardList,
    faIdCard,
    faListCheck,
    faChartSimple,
    faMagnifyingGlassPlus,
    faArrowDownShortWide,
    faArrowDownWideShort,
    faBriefcase,
    faPrint,
    faIdCardClip,
    faChartLine,
    faSquareRootVariable,
    faClipboardUser,
    faFileInvoiceDollar,
    faTableList,
    faCaretDown,
    faCodeBranch,
    faFilter,
    faReceipt,
    faCashRegister,
    faPercent,
    faPencil,
    faClockRotateLeft,
    faCaretUp,
    faSort,
    faCheckSquare,
    faCheck,
    faDiagramProject,
    faDownload,
    faEye,
    faAngleDown,
    faAddressBook,
    faFileSignature,
    faFileLines,
    faUsers,
    faGear,
    faUnlock,
    faChartBar,
    faCircleCheck as faCircleCheckSolid,
    faChalkboardUser,
    faShareFromSquare,
    faPlay,
    faClipboardQuestion,
    faLink,
    faIdBadge,
    faChartPie,
    faEnvelope,
    faGift,
    faUser,
    faFileImport,
    faFileExcel,
    faSync,
    faUserMinus,
    faUserPlus,
    faInfo,
    faCircleInfo,
    faEyeSlash,
    faStop,
    faFilePen,
    faHandshake,
    faCopy,
    faUpload,
    faAngleRight,
    faBroom,
    faMagnifyingGlassMinus,
    faBoxArchive,
    faFilePdf,
    faFileImage,
    faArrowUpWideShort,
    faWandMagicSparkles,
    faUserCheck,
    faShuffle,
    faComments,
    faPaperPlane,
    faClipboard,
    faThumbsUp,
    faThumbsDown,
    faCircleStop,
    faLock,
    faBan,
    faUsersGear,
    faCakeCandles,
    faHandsClapping,
    faSackDollar,
    faCaretLeft,
    faCaretRight,
    faHandHoldingDollar,
    faMoneyBillTrendUp,
    faPeopleGroup,
    faArrowRight,
    faArrowLeft,
    faChevronRight,
    faChevronLeft,
    faBookOpen,
    faCircleExclamation,
    faCalendarDays,
    faChevronDown,
    faCalculator,
    faClone,
    faFileZipper,
    faRankingStar,
    faArrowTrendDown,
    faArrowTrendUp,
    faArrowsLeftRight,
    faMinus,
    faClock,
    faCircle,
    faCirclePlus,
    faBullseye,
    faCircleXmark,
    faBarsProgress,
    faStarHalfStroke,
    faChalkboardTeacher,
    faTrophy,
    faAtom,
    faGaugeHigh,
    faBalanceScale,
    faTableColumns,
    faComment,
    faCalendar,
    faPhone,
    faBars,
    faRotate,
    faFile,
    faLifeRing,
    faArrowUpRightFromSquare,
    faUserGroup, faCogs, faTools, faTag, faShareNodes, faList, faStar, faCog,
    faMoneyBillWave,
    faRecycle,
    faSquarePollVertical,
    faDatabase,
    faExpand,
    faMinimize,
    faSitemap,
    faFileCircleCheck, faShapes, faUndo, faRedo, faPaste, faChevronUp, faHashtag, faRotateLeft,
    faRightLeft, faMagnifyingGlassChart, faSliders, faAlignLeft, faDotCircle, faSquareCheck, faCircleDot,
    faCircleChevronDown, faHeart, faRocket, faTriangleExclamation,
    faHourglassHalf,
    faUserTie,
    faUserSecret
} from '@fortawesome/free-solid-svg-icons';

import { faBell, faCircleCheck, faCircle as faCircleRegular, faClock as faClockRegular } from '@fortawesome/free-regular-svg-icons';
import { faHireAHelper, faSearchengin, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

library.add(
    faBuilding,
    faHouse,
    faPenToSquare,
    faTrashCan,
    faMagnifyingGlass,
    faArrowDownShortWide,
    faPlus,
    faLocationDot,
    faFloppyDisk,
    faXmark,
    faClipboardCheck,
    faFolderPlus,
    faClipboardList,
    faIdCard,
    faListCheck,
    faBell,
    faChartSimple,
    faMagnifyingGlassPlus,
    faArrowDownWideShort,
    faBriefcase,
    faPrint,
    faIdCardClip,
    faChartLine,
    faSquareRootVariable,
    faClipboardUser,
    faFileInvoiceDollar,
    faTableList,
    faCaretDown,
    faCodeBranch,
    faFilter,
    faReceipt,
    faCashRegister,
    faPercent,
    faPencil,
    faClockRotateLeft,
    faCaretUp,
    faCaretLeft,
    faCaretRight,
    faSort,
    faCheckSquare,
    faCheck,
    faDiagramProject,
    faXmark,
    faDownload,
    faEye,
    faAngleDown,
    faAddressBook,
    faFileSignature,
    faFileLines,
    faUsers,
    faGear,
    faUnlock,
    faChartPie,
    faEnvelope,
    faGift,
    faUser,
    faFileImport,
    faSearchengin,
    faFileExcel,
    faSync,
    faUserMinus,
    faUserPlus,
    faInfo,
    faCircleInfo,
    faCircle,
    faCircleCheck,
    faEyeSlash,
    faChartBar,
    faCircleCheckSolid,
    faChalkboardUser,
    faShareFromSquare,
    faPlay,
    faClipboardQuestion,
    faWhatsapp,
    faLink,
    faIdBadge,
    faStop,
    faFilePen,
    faHandshake,
    faCopy,
    faUpload,
    faAngleRight,
    faBroom,
    faMagnifyingGlassPlus,
    faMagnifyingGlassMinus,
    faBoxArchive,
    faFilePdf,
    faFileImage,
    faArrowUpWideShort,
    faWandMagicSparkles,
    faUserCheck,
    faShuffle,
    faComments,
    faPaperPlane,
    faClipboard,
    faThumbsUp,
    faThumbsDown,
    faCircleStop,
    faLock,
    faBan,
    faUsersGear,
    faCakeCandles,
    faHandsClapping,
    faSackDollar,
    faHandHoldingDollar,
    faMoneyBillTrendUp,
    faPeopleGroup,
    faArrowRight,
    faArrowLeft,
    faChevronRight,
    faChevronLeft,
    faBookOpen,
    faCircleExclamation,
    faCalendarDays,
    faCalculator,
    faChevronDown,
    faChevronUp,
    faClone,
    faFileZipper,
    faRankingStar,
    faArrowTrendUp,
    faArrowTrendDown,
    faArrowsLeftRight,
    faMinus,
    faClock,
    faClockRegular,
    faCircleRegular,
    faCirclePlus,
    faBullseye,
    faCircleXmark,
    faBarsProgress,
    faStarHalfStroke,
    faChalkboardTeacher,
    faTrophy,
    faAtom,
    faChartPie,
    faGaugeHigh,
    faBalanceScale,
    faTableColumns,
    faComment,
    faCalendar,
    faPhone,
    faBars,
    faRotate,
    faFile,
    faMoneyBillWave,
    faUserGroup,
    faCogs,
    faTools,
    faTag,
    faShareNodes,
    faCog,
    faLifeRing,
    faList,
    faTag,
    faStar,
    faExpand,
    faMinimize,
    faSitemap,
    faFileCircleCheck,
    faShapes,
    faUndo,
    faRedo,
    faPaste,
    faRecycle,
    faSquarePollVertical,
    faDatabase,
    faArrowUpRightFromSquare,
    faHashtag,
    faRotateLeft,
    faRightLeft,
    faMagnifyingGlassChart,
    faSliders,
    faAlignLeft,
    faCircleDot,
    faSquareCheck,
    faStar,
    faCalendar,
    faClock,
    faCircleChevronDown,
    faHeart,
    faRocket,
    faTriangleExclamation,
    faHourglassHalf,
    faUserTie,
    faUserSecret
);

// bootstrap
import * as bootstrap from 'bootstrap';

window.bootstrap = bootstrap;

// modals
import '@/assets/sass/components/custom-modal.scss';
import '@/assets/sass/elements/avatar.scss';

// perfect scrollbar
import PerfectScrollbar from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css';

//vue-meta
import { createHead } from '@vueuse/head';

const head = createHead();

//Sweetalert
import Swal from 'sweetalert2';

window.Swal = Swal;

// nouislider - later remove and add to page due to not working in page
import VueNouislider from 'vue3-nouislider';
import 'vue3-nouislider/dist/vue3-nouislider.css';

// vue input mask
import Maska from 'maska';

// smooth scroll
import { registerScrollSpy } from 'vue3-scroll-spy/dist/index';

registerScrollSpy(app, { offset: 118 });

//vue-i18n
import i18n from './i18n';

// datatables
import { ClientTable } from 'v-tables-3';

import Toast from 'vue-toastification';
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css';

// set default settings
import appSetting from './app-setting';

import axios from 'axios';

let user = localStorage.getItem('_user');
let portalPath = '';

if (isValidJson(user)) {
    user = JSON.parse(user);
    if (user.permissions?.includes('role:collaborator')) {
        portalPath = 'portal/';
    }
}

axios.defaults.baseURL = process.env.VUE_APP_HOST_API + portalPath;

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.get['Content-Type'] = 'application/json';
axios.defaults.headers.put['Content-Type'] = 'application/json';
axios.defaults.headers.delete['Content-Type'] = 'application/json';

axios.interceptors.request.use(function(config) {
    const storageToken = localStorage.getItem('_token');
    if (storageToken) {
        config.headers.Authorization = `Bearer ${storageToken}`;
    }
    return config;
});

app.config.globalProperties.$axios = axios;
window.axios = axios;

window.$appSetting = appSetting;
window.$appSetting.init();

import money from 'v-money3';
import acl from './acl';
import ptBr from 'element-plus/es/locale/lang/pt-br';

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        app,
        dsn: 'https://4362bb8d367b44afab826c581d025fdc@o4509322976165888.ingest.us.sentry.io/4509322977345536',
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration()
        ],
        // Tracing
        tracesSampleRate: 1.0, // Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

import panZoom from 'vue-panzoom'
import { isValidJson } from '@/helpers';

FloatingVue.options.themes.tooltip.html = true;

app.use(store)
    .use(Toast)
    .use(router)
    .use(acl)
    .use(i18n)
    .use(money)
    .use(PerfectScrollbar)
    .use(VueNouislider)
    .use(Maska)
    .use(ClientTable)
    .use(head)
    .use(HighchartsVue)
    .use(ElementPlus, { locale: ptBr })
    .component('font-awesome-icon', FontAwesomeIcon)
    .use(FloatingVue)
    .use(panZoom)
    .mount('#app');
